/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Statuspermissionschangeerror4Inputs */

const en_usermanagement_permissions_statuspermissionschangeerror4 = /** @type {(inputs: Usermanagement_Permissions_Statuspermissionschangeerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to change permissions`)
};

/**
* | output |
* | --- |
* | "Failed to change permissions" |
*
* @param {Usermanagement_Permissions_Statuspermissionschangeerror4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_statuspermissionschangeerror4 = /** @type {((inputs?: Usermanagement_Permissions_Statuspermissionschangeerror4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Statuspermissionschangeerror4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_statuspermissionschangeerror4(inputs)
});
export { usermanagement_permissions_statuspermissionschangeerror4 as "userManagement_permissions_statusPermissionsChangeError" }